import React from 'react';
import PropTypes from 'prop-types';
import { markAllAsRead } from '../actions/creators';

export default class ListActions extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  };

  handleClickMarkAllAsRead = () => {
    this.props.dispatch(markAllAsRead());
  };

  render() {
    return (
      <div className="notification-dropdown__header text-right" data-mount="list-actions">
        <a href="#" className="notification-dropdown__mark-as-read" data-action="mark-as-read" onClick={this.handleClickMarkAllAsRead}>Mark all as read</a>
      </div>
    );
  }
}
